// ...existing code...
import { createRouter, createWebHistory } from "vue-router";

const routes = [
  {
    path: "/auth",
    name: "AuthPage",
    component: () => import("@/views/AuthPage.vue"),
  },
  {
    path: "/login",
    name: "LoginPage",
    component: () => import("@/views/LoginPage.vue"),
  },
  {
    path: "/change-password",
    name: "ChangePasswordPage",
    component: () => import("@/views/ChangePasswordPage.vue"),
  },
  // {
  //   path: "/login",
  //   name: "loginPage",
  //   component: () => import("@/views/loginPage.vue"),
  // },
  {
    path: "/",
    name: "HomePage",
    component: () => import("@/views/HomePage.vue"),
  },
  {
    path: "/meeting",
    name: "MeetingPage",
    component: () => import("@/views/MeetingPage.vue"),
  },
  {
    path: "/user",
    name: "UserPage",
    component: () => import("@/views/UserPage.vue"),
  },
  {
    path: "/history",
    name: "HistoryPage",
    component: () => import("@/views/HistoryPage.vue"),
  },
  {
    path: "/history/:id",
    name: "HistoryDetailPage",
    component: () => import("@/views/HistoryDetailPage.vue"),
  },
  {
    path: "/allUsers",
    name: "AllUsersPage",
    component: () => import("@/views/ViewAllUser.vue"),
  }
];

const router = createRouter({
  history: createWebHistory(),
  routes,
});

export default router;
